import { render, staticRenderFns } from "./Errors.vue?vue&type=template&id=6a263322&"
import script from "./Errors.vue?vue&type=script&lang=js&"
export * from "./Errors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports